/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  BenisWithPermit,
  BenisWithPermitInterface,
} from "../../contracts/BenisWithPermit";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_wban",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_wbanPerSecond",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "_startTime",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "_rewardsDistributor",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "EmergencyWithdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "_allocPoint",
        type: "uint16",
      },
      {
        internalType: "contract IERC20",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_withUpdate",
        type: "bool",
      },
    ],
    name: "add",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "addSeconds",
        type: "uint32",
      },
    ],
    name: "changeEndTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "depositWithPermit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
    ],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "endTime",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_from",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_to",
        type: "uint256",
      },
    ],
    name: "getMultiplier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "massUpdatePools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "pendingWBAN",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "poolInfo",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "stakingToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "stakingTokenTotalAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "accWBANPerShare",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "lastRewardTime",
        type: "uint32",
      },
      {
        internalType: "uint16",
        name: "allocPoint",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "subSeconds",
        type: "uint32",
      },
    ],
    name: "reduceEndTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "_allocPoint",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "_withUpdate",
        type: "bool",
      },
    ],
    name: "set",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_wbanPerSecond",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_withUpdate",
        type: "bool",
      },
    ],
    name: "setWBANPerSecond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "startTime",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalAllocPoint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
    ],
    name: "updatePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "rewardDebt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "remainingWBANReward",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "wban",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "wbanPerSecond",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type BenisWithPermitConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BenisWithPermitConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BenisWithPermit__factory extends ContractFactory {
  constructor(...args: BenisWithPermitConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _wban: PromiseOrValue<string>,
    _wbanPerSecond: PromiseOrValue<BigNumberish>,
    _startTime: PromiseOrValue<BigNumberish>,
    _rewardsDistributor: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<BenisWithPermit> {
    return super.deploy(
      _wban,
      _wbanPerSecond,
      _startTime,
      _rewardsDistributor,
      overrides || {}
    ) as Promise<BenisWithPermit>;
  }
  override getDeployTransaction(
    _wban: PromiseOrValue<string>,
    _wbanPerSecond: PromiseOrValue<BigNumberish>,
    _startTime: PromiseOrValue<BigNumberish>,
    _rewardsDistributor: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _wban,
      _wbanPerSecond,
      _startTime,
      _rewardsDistributor,
      overrides || {}
    );
  }
  override attach(address: string): BenisWithPermit {
    return super.attach(address) as BenisWithPermit;
  }
  override connect(signer: Signer): BenisWithPermit__factory {
    return super.connect(signer) as BenisWithPermit__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BenisWithPermitInterface {
    return new utils.Interface(_abi) as BenisWithPermitInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BenisWithPermit {
    return new Contract(address, _abi, signerOrProvider) as BenisWithPermit;
  }
}
